import { theme } from '../style';
import styled, { css } from 'styled-components';
import { DASHED_BORDER, SCRIPT_INPUT_HEIGHT, SIDE_WIDTH } from '../const';

interface ContentProps {
  disabled: boolean;
}

export const Content = styled.div<ContentProps>`
  margin: 9px 0 0 0;
  display: flex;
  align-items: stretch;
  flex-wrap: nowrap;
  width: 100%;
  gap: 16px;
  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.75;
      pointer-events: none;
    `}
   ${theme.mediaQueryMaxWidth.md}{
    flex-direction:column;
    }
   }
`;

export const ScriptLoading = styled.div`
  position: absolute;
  top: 1px;
  bottom: 1px;
  left: 1px;
  right: 1px;
  background: white;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${DASHED_BORDER};
  ${theme.mediaQueryMaxWidth.md} {
    position: inherit;
  }
`;

export const Textarea = styled.textarea`
  box-sizing: border-box;
  padding: 8px 9px;
  min-height: 92px;
  height: 92px;
  border-radius: 6px;
  border: 1px solid ${theme.palette.gray40};
  font-size: 15px;
  &:focus,
  &:hover {
    box-shadow: none;
    outline: none;
    border: 1px solid ${theme.palette.covideoBlue100};
  }
  width: 100%;
  resize: none;
`;

export const LabelWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
`;

interface LabelProps {
  margin?: string;
}
export const Label = styled.div<LabelProps>`
  font-size: 14px;
  font-weight: 500;
  color: #9297a2;
  margin: ${({ margin }) => margin || 0};
`;
interface InputWrapperProps {
  width?: string;
}
export const InputWrapper = styled.div<InputWrapperProps>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
  width: ${({ width }) => width || '100%'};
`;

export const InputRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  gap: 16px;
  ${theme.mediaQueryMaxWidth.sm} {
    flex-direction: column;
  }
`;

export const SidebarWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;
  width: ${`${SIDE_WIDTH}px`};
  ${theme.mediaQueryMaxWidth.md} {
    width: 100%;
  }
`;

export const InputsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;
  ${theme.mediaQueryMaxWidth.md} {
    width: 100%;
  }
`;

export const GeneratedTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;
  flex-grow: 1;
  ${theme.mediaQueryMaxWidth.sm} {
    width: 100%;
    margin-bottom: 24px;
  }
`;

export const SlidersWrapper = styled.div`
  margin: 8px 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-height: 80px;
  ${theme.mediaQueryMaxWidth.md} {
    width: 100%;
  }
`;
export const SliderWrapper = styled.div`
  display: block;
  width: 100%;
`;
export const LevelWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  ${theme.mediaQueryMaxWidth.md} {
    flex-direction: column;
    width: 100%;
  }
`;
export const MobileLabelWrapper = styled.div`
  display: none;

  ${theme.mediaQueryMaxWidth.md} {
    flex-direction: row;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    width: 100%;
  }
`;
interface LevelLabelProps {
  textalign?: string;
  display?: string;
}
export const LevelLabel = styled.div<LevelLabelProps>`
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  min-width: 80px;
  color: ${theme.palette.gray80};
  text-align: ${({ textalign }) => textalign || 'left'};
  ${theme.mediaQueryMaxWidth.md} {
    display: ${({ display }) => display || 'none'};
  }
`;

export const ScriptInputWrapper = styled.div`
  position: relative;
  flex-grow: 1;
  display: flex;
  width: 100%;
`;
interface ScriptInputProps {
  disabled: boolean;
}
export const ScriptInput = styled.textarea<ScriptInputProps>`
  flex-grow: 1;
  resize: none;
  outline: none;
  overflow: auto;
  padding: 24px;
  border-radius: 6px;
  border: none;
  background-image: ${DASHED_BORDER};
  &:focus {
    outline: none;
  }
  ${({ disabled }) =>
    disabled &&
    css`
      pointer-events: none;
    `}
`;

interface HTMLPreviewProps {
  disabled: boolean;
}
export const HTMLPreview = styled.div<HTMLPreviewProps>`
  box-sizing: border-box;
  background: ${theme.palette.white};
  border-radius: 6px;
  background-image: ${DASHED_BORDER};
  flex-grow: 1;
  height: 100%;
  max-height: ${`${SCRIPT_INPUT_HEIGHT}px`};
  overflow: auto;
  padding: 24px;
  ${({ disabled }) =>
    disabled &&
    css`
      pointer-events: none;
      background: ${theme.palette.gray20};
      color: ${theme.palette.gray40};
      * {
        color: ${theme.palette.gray40};
      }
      .animated_gif_container img {
        opacity: 0.4;
      }
    `}
  font-size: 14px;
  * {
    font-size: 14px;
  }
`;

export const ButtonsWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
  margin: 16px 0 0;
  ${theme.mediaQueryMaxWidth.md} {
    flex-direction: column;
    align-items: start;
  }
`;

export const ImageWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 5;
  ${theme.mediaQueryMaxWidth.md} {
    height: 336px;
  }
`;

interface PromptLimitInfoProps {
  color?: string;
}

export const PromptLimitInfo = styled.div<PromptLimitInfoProps>`
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  color: ${({ color }) => color || theme.palette.magic100};
  margin-right: auto;
  display: flex;
  align-items: center;
  gap: 2px;
`;
